import React, { useEffect, useState } from 'react';
import { useOrderContext } from '../../../components/OrderProvider';
import Files from '@afosto/app-components-react/Files';
import { files as filesApi } from '@afosto/content/api/Files';

const OrderFiles = () => {
  const [files, setFiles] = useState([]);
  const [reloadFiles, setReloadFiles] = useState(true);
  const { order } = useOrderContext();
  const path = `orders/${order?.id}/files`;

  useEffect(() => {
    let isMounted = true;

    const fetchFiles = async filePath => {
      try {
        const response = await filesApi.listFiles({
          dir: filePath,
        });

        const { data = [] } = response;
        const formattedFiles = data.reduce(
          (acc, fileData) => [
            ...acc,
            {
              id: fileData.id,
              filename: fileData.label,
              dir: fileData.dir,
              url: fileData.url,
              createdAt: fileData.created_at,
              updatedAt: fileData.updated_at,
              mime: fileData.mime,
              fileSize: fileData?.metadata?.size,
              type: fileData.type,
            },
          ],
          [],
        );

        if (isMounted) {
          setFiles(formattedFiles);
        }
      } catch (err) {
        if (isMounted) {
          setFiles([]);
        }
      } finally {
        if (isMounted) {
          setReloadFiles(false);
        }
      }
    };

    if (path && reloadFiles) {
      fetchFiles(path).catch(() => {
        // Catch only
      });
    }

    return () => {
      isMounted = false;
    };
  }, [path, reloadFiles]);

  return (
    <Files
      files={files}
      uploadPath={path}
      onRemoveFile={() => setReloadFiles(true)}
      onAddFile={() => setReloadFiles(true)}
    />
  );
};

export default OrderFiles;
